module.exports = __webpack_public_path__ + "img/aa4f122989b56b231eb0d21f95a1b510.png";